export default __webpack_public_path__ + "static/media/inspector-shape-layer.4a401a80.svg";